export default __webpack_public_path__ + "8b3a45d01dd342d560da211a123f8561.png";